module.exports = __webpack_public_path__ + "static/media/Artboard 2.36fa7be5.png";